const loginCheckRouter = {
  path: '/login-check',
  name: 'loginCheck',
  component: () => import('@/views/login/login_check.vue'),
  meta: {hidden: true}
}

export default loginCheckRouter



// WEBPACK FOOTER //
// ./src/router/modules/loginCheck.js